import { render, staticRenderFns } from "./BasePlannerExam.vue?vue&type=template&id=4930bf22&"
import script from "./BasePlannerExam.vue?vue&type=script&lang=js&"
export * from "./BasePlannerExam.vue?vue&type=script&lang=js&"
import style0 from "./BasePlannerExam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports